import React from 'react';
import LotFavoritesButton from '../../favorites-button/js/LotFavoritesButton';
import LotItemMedia from './LotItemMedia';
import PropTypes from 'prop-types';
import LotInfo from "./LotInfo";

export default class LotItem extends React.PureComponent {

    render() {

        let item = this.props.item;

        return (
            <div className="lot-item">

                <div className="lot-item__header">
                    <LotItemMedia image={item.image} url={item.url}/>
                    <LotInfo lotNumber={item.lotNumber} statusLabel={item.statusLabel} statusName={item.statusName}/>
                </div>

                <div className="lot-item__content">
                    <div className="lot-item__info">
                        <div className="lot-item__auction-date">auction date <span
                            dangerouslySetInnerHTML={{__html: item.auctionDate}}/></div>
                        <a href={item.url}>
                            <div className="lot-item__address">
                                {item.addressLine1}
                            </div>
                            <div className="lot-item__location">
                                {item.addressLine2}
                            </div>
                        </a>
                        <div className="lot-item__description">{item.description}</div>
                    </div>
                    <div className="lot-item__footer">
                        <div className="lot-item__price">
                            <div className="lot-item__price-descriptor">
                                {item.priceDescriptor}{item.showPriceAsterix === true ?
                                <span className="disclaimer-mark">*</span> : null}
                            </div>
                            <strong>
                                {item.price}
                                {item.showFees === true ?
                                    <span className="disclaimer-mark disclaimer-mark--plus-fees">**</span>
                                    : null}
                            </strong>
                        </div>
                        <div className="lot-item__favorites-button">
                            <LotFavoritesButton button={item.saveButton}/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

LotItem.propTypes = {
    item: PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./app/components/lot-item/js/LotItem.js